#import "../../../../../common/graphql/NotesEntityFields.graphql"

query ListUserProfileNotes($id: UUID!) {
  userProfile(id: $id) {
    id
    notesByEntityId(orderBy: _CREATED_DATE_DESC) {
      nodes {
        ...NotesEntityFields
      }
    }
  }
}
